module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/6-active-302f0f226256e74dd597eef67af947d4.png";